import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  addToCartEditedInvoice,
  addTotalInvoiceAmount,
  calculateTotalPrice,
  removeItemFromEditCart,
} from "../../redux/features/sales.features";

const Item_cardEditInvoice = (props) => {
  let salesState = useSelector((state) => {
    return state.salesReducer;
  });

  let { EditInvoice, sales, loading } = salesState;
  let { invoiceItemList } = EditInvoice;

  const itemClick = (id) => {
    let a = (e) => [...invoiceItemList, props.data];
    props.onSelected(a);
  };
  const dispatch = useDispatch();
  const addItemToCart = (data) => {
    // if(props?.data?.sell)
    if (data?.priceVariant === "true") {
      if (props.invoiceCurrency === "LKR") {
        if (data?.sellPriceLocal2 === "" || data?.sellPriceLocal2 === "0")
          return alert("Please update selling local price 2 first");
      } else {
        if (
          data?.sellPriceForeigners2 === "" ||
          data?.sellPriceForeigners2 === "0"
        )
          return alert("Please update selling foreigner 2 price first");
      }
    } else {
      if (props.invoiceCurrency === "LKR") {
        if (
          !data?.sellPriceLocal ||
          data?.sellPriceLocal === "" ||
          data?.sellPriceLocal === "0"
        )
          return alert("Please update selling local price  first");
      } else {
        if (
          !data?.sellPriceForeigners ||
          data?.sellPriceForeigners === "" ||
          data?.sellPriceForeigners === "0"
        )
          return alert("Please update selling foreigner  price first");
      }
    }
    //  var indexSelected =  invoiceItemList.findIndex(x=>x.id === data.id)

    console.log("selected item", data);
    let indexSelected = invoiceItemList.findIndex((element) => {
      if (element.id === data.id) {
        return true;
      }
    });
    console.log("indexSelected", indexSelected);

    if (indexSelected !== -1) {
      dispatch(removeItemFromEditCart(indexSelected));
    } else {
      let a = [...invoiceItemList, data];
      dispatch(addToCartEditedInvoice(a));
    }
  };

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        cursor: props.data?.isSold ? "not-allowed" : "pointer",
        width: 200,
        height: 280,
      }}
      onClick={() =>
        props.data.isSold
          ? alert("This item was sold")
          : addItemToCart(props.data)
      }
      className={`flex flex-col items-center bg-${
        props?.data?.priceVariant === "true" ? "blue" : "red"
      }-500 text-center flex-wrap rounded`}
    >
      <div className="">
        {invoiceItemList.filter((x) => x.id === props.data.id).length !== 0
          ? invoiceItemList.map((x, i) => {
              return x.id === props.data.id ? (
                <div
                  key={i}
                  style={{
                    position: "absolute",
                    top: -9,
                    right: -15,
                    width: 50,
                    padding: 10,
                    borderRadius: "60%",
                    backgroundColor: "var(--main-color)",
                  }}
                  className="  text-white font-extrabold"
                >
                  {i + 1}
                </div>
              ) : null;
            })
          : null}
        {
          // props.data?.images && props.data?.images.map(x=>)
        <img
            style={{ height: "20vh" }}
            src="https://www.gemsngems.com/wp-content/uploads/2019/05/placeholder_2-300x300.jpg"
            alt="gem"
            className=""
          />
        }
      </div>
      <div className="flex w-full flex-col items-center justify-center">
        <div className="text-white text-2xl font-extrabold">
          {props.data.productId}
        </div>

        {props.invoiceCurrency === "USD" ? (
          <div className="text-white text-lg font-extrabold">
            {props?.data?.priceVariant === "true"
              ? props.data.sellPriceForeigners2 || "Price not available"
              : props.data.sellPriceForeigners || "Price not available"}{" "}
            {props.data.sellForeignersCurrency}
          </div>
        ) : (
          <div className="text-white text-lg font-extrabold">
            {props?.data?.priceVariant === "true"
              ? props.data.sellPriceLocal2 || "Price not available"
              : props.data.sellPriceLocal || "Price not available"}{" "}
            {props.data.sellLocalCurrency}
          </div>
        )}

        {props?.data?.priceVariant === "true" && (
          <div className="text-xs font-extrabold italic">
            Price variant item
          </div>
        )}
      </div>
    </div>
  );
};

export default Item_cardEditInvoice;
